// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1VFx1","tab":"Tabs_tab__16RWp","tabActive":"Tabs_tabActive__2afTa","indicator":"Tabs_indicator__Xshid"};